export const foldersTemplatesIds = [
  {
    key: null,
    desc: "Tutti"
  },
  {
    key: "dossier_1",
    desc: "Personalizzato"
  }
];

export function createfoldersYears() {
  let array = [];
  for (let x = -5; x < 10; x++) {
    array.push({ key: new Date().getFullYear() + x, desc: new Date().getFullYear() + x });
  }
  return array;
}

// export const deadlinePaymentChoices = [
//     {
//         key: null,
//         desc: "Tutti"
//     },
//     {
//         key: "due",
//         desc: "Pagato"
//     },
//     {
//         key: "unpaid",
//         desc: "Non pagato"
//     },
//     {
//         key: "not_paying",
//         desc: "Rifiutato"
//     }
// ];

const foldersCompanies = [
  {
    key: null,
    desc: "Tutti"
  }
];

export const categoryToDesc = {
  custom: "Personalizzato",
  bank: "Banca",
  budget: "Bilancio",
  statement: "Dichiarazioni",
  litigation: "Contenzioso"
};

export const arrayHeaderTable = [
  {
    id: "folderName",
    label: "Nome",
    formType: null,
    mappingIntoState: "folderName",
    className: "allWidth col6"
  },
  {
    id: "templateId",
    label: "Tipo di fascicolo",
    /* formType: "selectbox",*/
    dataSource: foldersTemplatesIds,
    boKey: "templateId",
    mappingIntoState: "templateId",
    className: "allWidth col6"
  },
  {
    id: "itemId",
    label: "Cliente",
    /* formType: "selectbox",*/
    boKey: "itemId",
    dataSource: foldersCompanies,
    mappingIntoState: "itemId",
    className: "allWidth col6"
  },
  {
    id: "refYear",
    label: "Periodo di riferimento",
    boKey: "refYear",
    dataSource: createfoldersYears(),
    mappingIntoState: "refYear",
    className: "allWidth col6"
  },

  // {
  //     id: "paymentChoice",
  //     label: "Pagamento",
  //     widthAdded: 0,
  //     formType: "selectbox",
  //     dataSource: deadlinePaymentChoices,
  //     nullValueMappedWith: "nd",
  //     boKey: "payment.status",
  //     mappingIntoState: "paymentChoice"
  // },
  {
    id: "actions",
    label: "",
    formType: null,
    hidden: false,
    className: "itsWidth"
  }
];
